/**
 * Split - Two-column layout component with consistent spacing
 */

import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SplitProps {
  children: [ReactNode, ReactNode];
  className?: string;
  reverse?: boolean;
  gap?: 'sm' | 'md' | 'lg' | 'xl';
  align?: 'start' | 'center' | 'end';
}

const gapMap = {
  sm: 'gap-8',
  md: 'gap-12',
  lg: 'gap-16',
  xl: 'gap-20',
};

export function Split({ children, className, reverse = false, gap = 'lg', align = 'center' }: SplitProps) {
  const alignMap = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
  };

  return (
    <div className={cn(
      'grid lg:grid-cols-2',
      gapMap[gap],
      alignMap[align],
      reverse && 'lg:grid-flow-dense',
      className
    )}>
      <div className={reverse ? 'lg:col-start-2' : ''}>
        {children[0]}
      </div>
      <div className={reverse ? 'lg:col-start-1 lg:row-start-1' : ''}>
        {children[1]}
      </div>
    </div>
  );
}

